import { useMutation } from "urql";

import { FreezeLimitDocument } from "../../../graphql/generated.ts";

export const useFreezeLimit = () => useMutation(FreezeLimitDocument);
